import { shallowMount } from "@vue/test-utils";
import FloatingError from "@/components/core/custom/FloatingError";

describe("FloatingError component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(FloatingError);
  });

  it("Renders del component FloatingError", () => {
    expect(wrapper.exists()).toBe(true);
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
